import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-calculation-detail',
  templateUrl: './calculation-detail.component.html',
  styleUrls: ['./calculation-detail.component.scss']
})
export class CalculationDetailComponent implements OnInit {

  // fixed total rolling rate (1% of loss), shared by all levels
  public static readonly ROLLING_RATE = 0.01;

  @Input() row: any;

  public remark = 'Calculation';
  public amount = 0;
  public balance: any = null;
  public date: any = null;
  public rawFormula = '';
  public lines: any[] = [];
  public parsed = false;
  // Self-audit tick from the backend (api referral-formula.js): does the decoded breakdown
  // sum back to the amount actually paid? null = not a verifiable referral-water row.
  public verified: boolean | null = null;
  public breakdownTotal: number | null = null;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    const r = this.row || {};
    this.remark = r.remark || 'Calculation';
    const debit = parseFloat(r.debit || 0);
    const credit = parseFloat(r.credit || 0);
    const rc = r.report_commission;
    this.amount = (rc !== null && rc !== undefined && !isNaN(parseFloat(rc))) ? parseFloat(rc) : (debit - credit);
    this.balance = r.balance;
    this.date = r.effective_date || r.date || r.timestamp || null;
    this.rawFormula = r.formula_param || r.report_formula_param || '';
    const cb = r.calculation_breakdown;
    if (cb && cb.type === 'referral-water') {
      this.verified = !!cb.matches;
      this.breakdownTotal = (cb.total !== null && cb.total !== undefined) ? parseFloat(cb.total) : null;
    }
    this.parseFormula();
  }

  private parseFormula(): void {
    if (!this.rawFormula) { this.parsed = false; return; }
    const lines: any[] = [];
    for (const tk of this.rawFormula.split('+')) {
      const t = (tk || '').trim();
      if (!t) continue;
      const segs = t.split(':');
      // expected token: <customer_code>:L<tier>:<game...>:<profit>*<rate>*<pool>*<tier_rate>
      if (segs.length < 4) { this.parsed = false; return; }
      const math = segs[segs.length - 1];
      const nums = math.split('*').map((x: string) => parseFloat(x));
      if (nums.length < 4 || nums.some((n: number) => isNaN(n))) { this.parsed = false; return; }
      // client-facing spelling: Lose × GameRate × 1% × Rate × PlayerShare.
      // GameRate is the automated-rule rate (per game, general fallback — today 0.005 → 50%)
      // and Rate is the stored level rolling rate: L1 100% / L2 30% / L3 20%.
      const rolling = CalculationDetailComponent.ROLLING_RATE;
      const dispGameRate = nums[1] / rolling;
      lines.push({
        source: segs[0],
        level: segs[1],
        game: segs.slice(2, segs.length - 1).join(':'),
        profit: nums[0], rate: nums[1], pool: nums[2], tier: nums[3],
        gameRatePct: Math.round(dispGameRate * 100 * 100) / 100,
        rollingPct: Math.round(rolling * 100 * 100) / 100,
        ratePct: Math.round(nums[3] * 100 * 100) / 100,
        poolPct: Math.round(nums[2] * 100 * 100) / 100,
        value: nums.reduce((a: number, b: number) => a * b, 1)
      });
    }
    if (lines.length === 0) { this.parsed = false; return; }
    this.lines = lines;
    this.parsed = true;
  }

  public parseFloat(v: any): number {
    return parseFloat(v);
  }
}
